import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import CustomFieldsMixin from "@Shared/utils/board-mixins/custom-fields-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomFieldDefinition",
  components: {
    MaterialInput
  },
  mixins: [CustomFieldsMixin],
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "text",
      validator(value) {
        const validTypes = ["text", "numeric", "monetary", "phone", "date", "address", "email", "dropdown"];
        return _includesInstanceProperty(validTypes).call(validTypes, value);
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    typeDefinition() {
      return this.typeDefinitions[this.type];
    }
  },
  destroyed() {
    var _context;
    _findInstanceProperty(_context = $(this.$el)).call(_context, "[data-toggle='tooltip'").tooltip("dispose");
  },
  mounted() {
    this.$nextTick(() => {
      var _context2;
      _findInstanceProperty(_context2 = $(this.$el)).call(_context2, "[data-toggle='tooltip'").tooltip();
    });
  }
});